// extracted by mini-css-extract-plugin
module.exports = {"koplaTeaser":"KoplaTeaser_koplaTeaser___mJn4","imageContainer":"KoplaTeaser_imageContainer__jbv59"};